import React from 'react'

import "../../style/PartsList.css"
import config from '../../data/config';
import { useSelectedCategory, useSelectedParts, updateParts, useDispatch } from '../../context/AppContext';

const { parts_info, category_info } = config;
//後でcategory_orderからさらにorderを取り出す

//ここではカテゴリー内のパーツリストを表示させる
const PartsList = () => {
  //selectedCategory: PartsType.Hairが初期値で入っている
  // selectedParts: { [PartsType.Hair]: PartsID.DefaultHair,...}が初期値で入っている
  const selectedCategoryId = useSelectedCategory();
  const selectedParts = useSelectedParts();
  // のでselectedParts[selectedCategory]でそれぞれ取り出せる
  const selectedPartsId = selectedParts[selectedCategoryId]
  //category_info: { [PartsType.Hair]: { ...} }の { ...} 部分を取り出す
  const category = category_info[selectedCategoryId]

  const dispatch = useDispatch();


  if(!category){
    return null;
  }

  const { order } = category;
  //取り出したorderがないとき
  if(!order || !order.length){
    return null;
  }

  return (
    <div className='parts-list'>
      {/* 1.category_info内のorderのパーツリストをmapで回しparts_info内の同じPartsIDのcomponentを取りだす */}
      {/* 2.partsIDが同じならselectedのクラススタイルを設定する */}
      {order.map((partsId) => {
        const parts = parts_info[partsId] || {};
        const {name, component: SVGImage } = parts;

        //アイテムをクリックしたときのカテゴリーIdとパーツIdを更新する
        const handleClick = () => {
          dispatch(
            updateParts({
              categoryId: selectedCategoryId,
              partsId: partsId
            })
          )
        }
        return (
          <div
            className={`parts ${selectedPartsId === partsId ? "selected" : "" }`}
            key={partsId}
            onClick={handleClick}
          >
            <SVGImage />
            <span className='parts-name'>{name}</span>
          </div>
        )
      })}
    </div>
  )
}

export default PartsList
